export type AssistantFeedbackRecord = {
  question: string;
  articleId: string;
  helpful: boolean;
  route: string;
  createdAt: string;
};

export type AssistantUnansweredRecord = {
  question: string;
  route: string;
  createdAt: string;
};

const FEEDBACK_STORAGE_KEY = "ai-assistant-feedback-v1";
const UNANSWERED_STORAGE_KEY = "ai-assistant-unanswered-v1";
const MAX_RECORDS = 200;

const normalizeRoute = (route: string) => route
  .split("?")[0]
  .replace(/\/devices\/[^/]+/, "/devices/:deviceId");

const appendRecord = <T,>(storageKey: string, record: T) => {
  try {
    const savedValue = localStorage.getItem(storageKey);
    const savedRecords = savedValue ? JSON.parse(savedValue) : [];
    const records = Array.isArray(savedRecords) ? savedRecords : [];
    localStorage.setItem(storageKey, JSON.stringify([...records, record].slice(-MAX_RECORDS)));
  } catch (error) {
    console.warn("Не удалось сохранить данные помощника", error);
  }
};

export const saveAssistantFeedback = (
  question: string,
  articleId: string,
  helpful: boolean,
  currentRoute: string
) => appendRecord<AssistantFeedbackRecord>(FEEDBACK_STORAGE_KEY, {
  question,
  articleId,
  helpful,
  route: normalizeRoute(currentRoute),
  createdAt: new Date().toISOString()
});

export const saveUnansweredQuestion = (question: string, currentRoute: string) =>
  appendRecord<AssistantUnansweredRecord>(UNANSWERED_STORAGE_KEY, {
    question,
    route: normalizeRoute(currentRoute),
    createdAt: new Date().toISOString()
  });
